
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/dostavka",
      function () {
        return require("private-next-pages/dostavka.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/dostavka"])
      });
    }
  